import React from "react";
import { useTranslation } from "react-i18next";
import StatusDeposit from "./StatusDeposit";
import { EDepositStatus } from "src/types";

const DepositSuccess: React.FC = (): JSX.Element => {
  const { t } = useTranslation();
  
  return (
    <StatusDeposit
      status={EDepositStatus.Success}
      title={t("DEPOSIT_STATUS.DEPOSIT_SUCCESSFUL")}
      message={t("DEPOSIT_STATUS.DEPOSIT_PROCESSED_SUCCESSFULLY")}
    />
  );
};

export default DepositSuccess;
